import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { loginUserCheck, logoutUser, privilegeCreate } from '../redux/actions'

class AdminAddPrivilege extends Component {

    constructor(){
        super()
        this.state = {
            photo: "",
            title: "",
            point: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
    }
    
    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _onHandleChange(event) {
        if(event.target.files) {
            this.setState({
                [event.target.name]: event.target.files[0]
            })
        } else {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
    }

    _onSubmit() {
        let data = {
            privilege_id: (new Date()).getTime(),
            img: this.state.photo,
            title: this.state.title,
            point: this.state.point,
            created_by: this.props.user
        }
        if(this.state.photo && this.state.title && this.state.point) {
            this.props.privilegeCreate(data)
        } else {
            alert("Please fill in a form...")
        }
    }

    render() {
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-addprivilege">
                    <Nav active="privilege"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>สิทธิพิเศษ : เพิ่มรายการ</h2>
                            </div>
                            <div className="info">
                                <div className="adjust">
                                    <form action="" className="photo">
                                        <div className="privilege-title">
                                            <p>รูปภาพสิทธิพิเศษ (200x182px)</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.photo.name}</p>
                                        </div>
                                        <div className="photo-input">
                                            <input id="photo" type="file" name="photo" accept="image/*" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="photo">เลือกรูปภาพ</label>
                                        </div>
                                    </form>
                                    <form className="text">
                                        <p>ชื่อเรื่อง</p>
                                        <input type="text" name="title" onChange={(event) => this._onHandleChange(event)}></input>
                                        <p>คะแนน</p>
                                        <input type="number" name="point" onChange={(event) => this._onHandleChange(event)}></input>
                                    </form>
                                    <div className="btn-submit">
                                        {
                                            (this.props.loading) ?
                                            <p style={{textAlign: 'center'}}>Loading...</p>
                                            : <BtnSave click={() => this._onSubmit()}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, privilege }) => {
    return { 
        user: auth.user,
        loading: privilege.loading
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, privilegeCreate
})(AdminAddPrivilege)